import {
  ICON_SIDEBAR,
  STANDARD_SIDEBAR
} from '@ublique/components/SideNavPage/constants'

export default (scenarioModelConfig) => {
  // If not specified, the default sidebar is set to 'standard'
  const { sidebar = STANDARD_SIDEBAR } = scenarioModelConfig
  // See https://spindoxspa.atlassian.net/browse/UBPLAT-1885
  switch (sidebar) {
    case STANDARD_SIDEBAR:
    case ICON_SIDEBAR:
    case false:
      return sidebar
    default:
      return STANDARD_SIDEBAR
  }
}
